import React from 'react'
import { useEffect } from 'react'
import { useRef } from 'react'
import { useState } from 'react'
import styles from "../css/ErrorPage.module.css"
import { debounce } from 'lodash'
import Header from '../../LandingPage/Header'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const [showMenu,setShowMenu] = useState(false)
  const [scrolled,setScrolled] = useState(false)
  const box = useRef(null)
  const navigate = useNavigate()

    useEffect(() => {
        const container = box.current
        const handleScroll = debounce(() => {
            if (box.current){
                setScrolled(box.current.scrollTop>0)
            }
        }, 100);

        box.current?.addEventListener('scroll', handleScroll)
        return () => {
            container?.removeEventListener('scroll', handleScroll)
            handleScroll.cancel()
        };
    }, [])

    return (
        <div className = {`${styles.wrapper} ${showMenu ? styles.openMenu : ""}`} ref = {box}>
            <Header
                hideLinks = {true}
                showMenu = {showMenu}
                setShowMenu = {setShowMenu}
                scrolled = {scrolled}
            />
            <div className = {styles.content}>
                <div className = {styles.errorBody}>
                    <div className={styles.errorLeft}>
                        <div className={styles.errorEyebrow}>Error 404</div>
                        <div className={styles.errorCode}><em>404</em></div>
                        <div className={styles.errorTitle}>This page doesn't exist.</div>
                        <div className={styles.errorDesc}>
                            The page you're looking for may have been moved, deleted, or never existed. Let's get you back home.
                        </div>
                        <div className={styles.errorActions}>
                            <button className={styles.btnPrimary} onClick = {()=>navigate("/")}>← Back to Home</button>
                        </div>
                    </div>
                    <div className={styles.errorRight}>
                        <div className={styles.illus404}>
                            <div className={styles.illusBgText}>404</div>
                        </div>
                        <div className = {styles.imageArea}>
                        <img
                            src = "/assets/404Error.png"
                            alt="404 ERROR"
                            loading="lazy"
                        />
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <p>© {new Date().getFullYear()} NotePro. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default NotFoundPage